import { safeLocalStorage } from '@ifixit/utils';

export type LoginMethod = 'email' | 'loginWithCode' | 'google' | 'apple' | 'facebook' | 'sso';

const STORAGE_KEY = 'last-login-method';

export function getLastLoginMethod(): LoginMethod | null {
   return safeLocalStorage.getItem(STORAGE_KEY) as LoginMethod | null;
}

export function setLastLoginMethod(method: LoginMethod): void {
   safeLocalStorage.setItem(STORAGE_KEY, method);
}
